import { BaseComponent } from './../base/base.component';
import { Component, OnInit, Input } from '@angular/core';

declare var bootbox:any;

@Component({
  selector: 'app-organization-employees',
  template: require('./organization-employees.component.html')
})
export class OrganizationEmployeesComponent extends BaseComponent implements OnInit {

  public organization = {
      name: "",
      isDemo: 0
  };
  public employees = [];

  public organizationId = -1;

  ngOnInit() {
    super.ngOnInit();
  }

  routeParamsUpdated() {
    this.organizationId = this.currentRouteParams["orgId"];
    this.loadOrganization();
  }

  public loadOrganization() {
    this.busy = this.lsApi.getOrganizationById(this.organizationId).subscribe(resp => {
        if(resp.status) {
            this.organization = resp.data[0];
            this.loadEmployees();
        }
    },
    error => {
        console.log(error);
    });
  }


  public getDepartment(mgr) {
    if(mgr.department!=null)
      return " (" + mgr.department.name + ")";
    else
      return "";
  }

  public loadEmployees() {
    this.busy = this.lsApi.getEmployees(this.organizationId).subscribe(resp => {
        if(resp.status) {
            this.employees = resp.data;
            if(this.employees.length>0) {
              this.initDataTable(
                "#tblData",
                [
                  { "bSearchable": true },  //col 2
                  { "bSearchable": true },  //col 3
                  { "bSearchable": false, bSortable: false } //col 1
                ],0
              );
            }
        }
    },
    error => {
        console.log(error);
    });
  }

  public deleteEmployee(org) {
    
    bootbox.confirm({message:"Do you want to delete this employee and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {


            this.busy = this.lsApi.deleteEmployeeById(org.employeeId).subscribe(resp => {
                if(resp.status) {
                  this.appToast.success("Employee Successfully Deleted","Employee Deleted");
                  this.loadEmployees();
                }
            },
            error => {
                console.log(error);
            });

            
        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organization-employees/organization-employees.component.ts